<template>
	<JBox>
		<CFormInput
			label="Option Key"
			componentName="JInputText"
			name="optionKey"
			class="s-mb-6"
			v-model="form.optionKey"
			@input="handleInput"
			@blur="convertToTechnicalNames"
		/>
	</JBox>
</template>

<script>
import snakeCase from "lodash.snakecase"

export default {
	props: {
		value: {
			type: Object,
			default: () => ({})
		}
	},

	data() {
		return {
			form: {}
		}
	},

	methods: {
		convertToTechnicalNames() {
			this.$emit("input", {
				...this.form,
				optionKey: snakeCase(this?.form?.optionKey)
			})
		},

		handleInput() {
			this.$emit("input", { ...this.form })
		}
	},

	watch: {
		value: {
			handler(newVal) {
				this.form = { ...newVal }
			},
			immediate: true,
			deep: true
		}
	}
}
</script>
